export default __webpack_public_path__ + "static/media/reset-hovered.3fba6e6a.svg";